import { render, staticRenderFns } from "./GridCellNonClickable.vue?vue&type=template&id=10365894&"
import script from "./GridCellNonClickable.vue?vue&type=script&lang=js&"
export * from "./GridCellNonClickable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports